export default "__VITE_ASSET__CJysccRH__"